<template>
  <client-only>
    <div class="post-description">
      <div class="header">
        <p class="name">
          <template v-if="likes_description">
            {{
              $t(
                "video_watch.interactions.likes",
                {
                  likes: mutableLikes,
                },
                mutableLikes
              )
            }}
          </template>
        </p>

        <div style="display: flex; height: fit-content">
          <ButtonLike
            style="margin-inline: 7.5px"
            @toggleLike="toggleLike"
            :liked="liked"
            v-if="likes_enabled"
          />
          <CommentButton v-if="SHOW_COMMENTS" style="margin-inline: 7.5px;" :post="post" :model="model" />
          <ButtonSocialShare
            style="margin-inline: 7.5px"
            :sharing="{ url: shareUrl }"
          />
          <SendTokensButton
            v-if="showTokens"
            :model="model"
            :post="post"
            style="margin-inline: 7.5px"
          />
        </div>
      </div>

      <p class="description">{{ post.description }}</p>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { Post } from "~/types/Post";

/* Props */
interface _Props {
  model?: any;
  post?: Post;
}

const { post, model } = defineProps<_Props>();

const shareUrl = `${document.location.origin}/@${model.username}/post/${post.post_id}`;
const mutableLikes = ref<number>(+(JSON.parse(post.likes) || 0) || 0);

function toggleLike(value: number) {
  if (Object.keys(post).length == 0 || Object.keys(model).length == 0) return;

  mutableLikes.value = value
    ? mutableLikes.value + 1
    : (mutableLikes.value || 1) - 1;

  resources.postLike.toggleLike({ postID: post.post_id });
}

const liked = computed(() => post.interaction?.liked);
const likes_enabled = computed(() => post.interaction?.likes_enabled);
const likes_description = computed(() => mutableLikes.value > 0 && likes_enabled.value);
const SHOW_COMMENTS = computed(() => post.available);
const showTokens = computed(() => post.front_container && post.front_container !== "tokens");
</script>

<style lang="scss" scoped>
.post-description {
  margin: 10px 5px;
  text-align: left;
  // min-height: 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-direction: normal;

    width: 100%;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .name {
    margin: auto 0 3px 0;
    text-transform: capitalize;
  }

  .description {
    margin: 0.5em 0 0 0;
    color: var(--pallete_clear_text_color);
  }
}
</style>
